import React, { useContext } from 'react'
import StepFigure from 'app/React/Components/Main/StepFigure'
import FormStep2 from "app/React/Components/Form/Step2/FormStep2";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Step2() {
  const {
    currentVariant,
    order,
    setCurrentStep,
  } = useContext(ConfiguratorContext)

  const steps = currentVariant.steps ?? {}

  if (steps['2'] === undefined) {
    setCurrentStep('3')
    return null
  }

  const settings = steps['2']?.settings ?? {}
  const hasNonPaymentTypeOptions = () => {
    for (let setting in settings) {
      const options = settings[setting].options

      for (let option in options) {
        if (options[option].hide_on !== order.paymentType && options[option].hide_on !== 'all') {
          return true
        }
      }
    }

    return false
  }

  if (!hasNonPaymentTypeOptions()) {
    return null
  }

  return (
    <div id='step-2'>
      <StepFigure step={steps['2'].step_id}/>
      <FormStep2 form={steps['2']}/>
    </div>
  )
}
